import React, { useMemo } from 'react';
import { isNoteNode } from '../../FlowchartView/utils/noteUtils';
import { isMilestoneNode, getMilestoneAnchor } from '../../FlowchartView/utils/milestoneUtils';
import ChainHeaders from '../../FlowchartView/components/ChainHeaders';
import { boardChromeKey } from '../utils/boardChromeKey';
import { BoardMilestone, BoardMission, BoardNote } from './BoardNode';

function BoardCanvas({
  worldRef,
  boxRef,
  tasks,
  positions,
  nodeDimensions,
  selectedIds,
  flow,
  lockStates,
  statuses,
  goToTask,
  menuActionsRef,
  isFocusMode = false,
}) {
  const chromeKey = useMemo(() => boardChromeKey(flow), [flow]);
  return (
    <div
      className="board-view__world flowchart__canvas"
      ref={worldRef}
    >
      <ChainHeaders
        tasks={tasks}
        positions={positions}
        nodeDimensions={nodeDimensions}
        chains={flow.chains}
        onMoveLeft={flow.onChainMoveLeft}
        onMoveRight={flow.onChainMoveRight}
        isFocusMode={isFocusMode}
        isMultiCampaignMode={!!flow.isMultiCampaignMode}
      />
      {tasks.map((task) => {
        if (!task?.id) return null;
        const pos = positions.get(task.id);
        if (!pos) return null;
        if (isNoteNode(task)) {
          return (
            <BoardNote
              key={task.id}
              task={task}
              pos={pos}
              selected={selectedIds.has(task.id)}
              onRename={flow.onRenameTask}
              onDelete={flow.onDeleteTask}
              menuActionsRef={menuActionsRef}
            />
          );
        }
        if (isMilestoneNode(task)) {
          const hostId = getMilestoneAnchor(task)?.hostTaskId;
          return (
            <BoardMilestone
              key={task.id}
              task={task}
              pos={pos}
              hostPosition={hostId ? positions.get(hostId) || null : null}
              selected={selectedIds.has(task.id)}
              tasks={tasks}
              flow={flow}
              statuses={statuses}
              menuActionsRef={menuActionsRef}
            />
          );
        }
        return (
          <BoardMission
            key={task.id}
            task={task}
            pos={pos}
            selected={selectedIds.has(task.id)}
            flow={flow}
            lockState={lockStates?.[task.id]}
            goToTask={goToTask}
            menuActionsRef={menuActionsRef}
            chromeKey={chromeKey}
          />
        );
      })}
      <div ref={boxRef} className="board-view__selection-box" />
    </div>
  );
}

export default BoardCanvas;
